export default "__VITE_ASSET__BIxBcHoQ__"